// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import moment from 'moment-timezone'

function startOfDay(date, timezone) {
  let d = moment(date).format("YYYY-MM-DD");
  if (timezone === undefined) {
    timezone = moment.tz.guess();
  }
  return moment.tz(d, timezone);
}

function endOfDay(date, timezone) {
  const t = startOfDay(date, timezone);
  return t.add(1, 'd').add(-1, 's');
}

function toDateTime (date, time, timezone) {
  let c = moment(date).format("YYYY-MM-DD");
  if (timezone === undefined) {
    timezone = moment.tz.guess();
  }
  let datestr = `${c} ${time}`;
  let d = moment.tz(datestr, "YYYY-MM-DD hh:mm a", timezone);
  return d;
}

function toTimePickerTime(date, timezone) {
  if (timezone === undefined) {
    timezone = moment.tz.guess()
  }
  return moment.tz(date, timezone).format("HH:mm:ss");
}

function toTime (time) {
  return {
    hh: time.format('hh'),
    mm: time.format('mm'),
    a: time.format('a'),
  };
}

function diff(start, end) {
  let s = moment(start);
  let e = moment(end);
  return moment.duration(e.diff(s));
}

function generateEvent(date, time, timezone, range_min, description) {
  const intake = toDateTime(date, time, timezone).toDate();
  const range_hr = range_min / 60.0;
  const event = {Intake: intake, Title: 'Dose intake', Range: range_hr};
  if (description) {
    event.Description = description;
  }
  return event;
}

function generateSingleDose(date, time, timezone, range, description) {
  let evts = [];
  evts.push(generateEvent(date, time, timezone, range, description));
  return evts;
}

function generateCustomDoses(start, end, time, days, timezone, range, description) {
  let dur = diff(start, end);
  let evts = [];
  for (let i = 0; i <= dur.asDays(); i++) {
    let d = moment(start).add(i, 'd');
    days.forEach(function(wd) {
      if (d.format('ddd') == wd) {
        let e = generateEvent(d, time, timezone, range, description);
        evts.push(e);
      }
    });
  }
  return evts;
}

function generateRepeatedDoses(start, end, time, timezone, range, description) {
  let d = diff(start, end);
  let evts = [];
  for (let i = 0; i <= d.asDays(); i++) {
    let e = generateEvent(moment(start).add(i, 'd'), time, timezone, range, description);
    evts.push(e);
  }
  return evts
}

function getDoseStatusClass(dose) {
  let e = moment(dose.Intake).add({ hours: dose.Range, seconds: 1 });
  let r = dose.Range || 1;
  let s = moment(dose.Intake).subtract({ hours: r, seconds: 1 });
  if (dose.Taken && dose.Status == "Open") {
    return moment(dose.Taken).isBefore(e) && moment(dose.Taken).isAfter(s)
      ? "Ok"
      : "Late";
  }
  let now = moment();
  return now.isAfter(e) ? "Overdue" : "Close";
}

export {
  toDateTime,
  toTime,
  diff,
  startOfDay,
  endOfDay,
  getDoseStatusClass,
  generateCustomDoses,
  generateRepeatedDoses,
  generateSingleDose,
  toTimePickerTime,
}
